import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { RiMailFill, RiTimerFill, RiFileTextFill } from 'react-icons/ri'
import * as S from './styles.js'

const Timer = () => {
  const [showSms, setShowSms] = useState(false)
  const [showTime, setShowTime] = useState(false)
  const [showTermsModal, setShowTermsModal] = useState(false)
  const [termsTab, setTermsTab] = useState('terms')
  const liveHours = useSelector((state) => state.user.firmInfo.liveHours)
  const { pointSafetyStockNotice, smsPoint, isSurenotify } = useSelector((state) => state.user.firmInfo)

  const showSmsWarn = () => {
    if (pointSafetyStockNotice) {
      return ' #您的簡訊點數過低！建議您盡快儲值。'
    } else {
      return ''
    }
  }
  const showTimeWarn = () => {
    if (liveHours) {
      const calc = liveHours?.split(':')
      const warning = parseInt(calc[0])
      if (warning <= 100) {
        return ' #您的直播時數低於100小時！'
      }
      if (warning <= 50) {
        return ' #您的直播時數低於50小時！'
      }
      if (warning == 0) {
        return ' #您的直播時數低於1小時！'
      }
    }
    return ''
  }

  const parseLiveHours = () => {
    if (liveHours) {
      const calc = liveHours?.split(':')

      return `${calc[0]}小時${calc[1]}分${calc[2]}秒`
    }
    return `---`
  }

  return (
    <>
      <S.Container>
        <S.ToggleButton showWarn={!showTimeWarn()} onClick={() => setShowTime(!showTime)}>
          <RiTimerFill />
          {showTime && (
            <S.Span>
              剩餘直播時數：<span>{parseLiveHours()}</span> <S.Alert>&nbsp;{showTimeWarn()}</S.Alert>
            </S.Span>
          )}
        </S.ToggleButton>
        {!isSurenotify && (
          <S.ToggleButton showWarn={!showSmsWarn()} onClick={() => setShowSms(!showSms)}>
            <RiMailFill />
            {showSms && (
              <S.Span>
                剩餘簡訊點數：<span>{smsPoint}</span> <S.Alert>&nbsp;{showSmsWarn()}</S.Alert>
              </S.Span>
            )}
          </S.ToggleButton>
        )}
        <S.ToggleButton showWarn onClick={() => setShowTermsModal(true)}>
          <RiFileTextFill />
        </S.ToggleButton>
      </S.Container>

      {showTermsModal && (
        <S.ModalOverlay onClick={() => setShowTermsModal(false)}>
          <S.ModalContainer onClick={(e) => e.stopPropagation()}>
            <S.ModalHeader>
              <S.ModalTabs>
                <S.ModalTab active={termsTab === 'terms'} onClick={() => setTermsTab('terms')}>
                  使用者條款
                </S.ModalTab>
                <S.ModalTab active={termsTab === 'privacy'} onClick={() => setTermsTab('privacy')}>
                  隱私權政策
                </S.ModalTab>
              </S.ModalTabs>
              <S.ModalClose type="button" onClick={() => setShowTermsModal(false)} aria-label="關閉">
                ×
              </S.ModalClose>
            </S.ModalHeader>

            <S.ModalBody>
              {termsTab === 'terms' && (
                <section>
                  <h1>使用者條款</h1>

                  <p>非常歡迎您使用開能有限公司（以下簡稱「我們」或「本公司」）協助銷售之「Bombmy幫賣」平台（以下簡稱「本軟體」），本軟體由根垣科技有限公司開發並擁有全部智慧財產權與技術責任。為了讓您能夠安心使用本軟體的各項服務與資訊（以下簡稱「本服務」），特此向您說明本軟體的使用者條款（以下簡稱「本條款」），以保障您的權益。您於使用本服務前，應詳細閱讀本條款所有內容，具體條款如下：</p>

                  <h2>一、認知及同意條款</h2>

                  <p>(一)當您使用本服務時，即表示您已閱讀、了解並同意本條款所有內容，並完全接受本服務現有與未來衍生的服務項目、內容及所有規範。您不同意本條款之內容時，請停止使用本服務。</p>

                  <p>(二)如您為未滿十八歲之未成年人或無完全行為能力人，請事前徵得家長（監護人、法定代理人）陪同閱讀、瞭解並同意本條款之所有內容及其後修改變更後，再註冊為會員並使用本服務。當未成年或無完全行為能力使用者使用或繼續使用本服務，視為其家長（監護人、法定代理人）已閱讀、瞭解並同意本條款之所有內容及其後修改變更之內容。</p>

                  <p>(三)您同意您的意思表示，得以包含但不限於書面或電子文件作為表示方式。依本條款交換之電子文件，其效力與書面文件相同。</p>

                  <h2>二、條款更新</h2>

                  <p>
                    您同意本軟體有權於任何時間修改或變更本條款及隱私權政策內容，為確保權益完整，您應定期或不定期檢視本條款及隱私權政策。建議您隨時注意該修改或變更。當您於任何修改或變更後繼續使用本服務，視為您已閱讀、了解並同意接受該修改或變更內容。如果您不同意本條款或隱私權政策進行的修改，請離開本軟體並立即停止使用本服務。同時，您應刪除個人檔案並註銷會員資格，本軟體亦有權刪除會員個人檔案並註銷會員資格。
                  </p>

                  <h2>三、會員帳號及安全</h2>

                  <p>(一)您如欲使用本軟體之完整服務時，需依本軟體指定之方法註冊成為會員（以下簡稱「會員」或「您」），付款完畢後，系統會自動幫您開通帳號。</p>

                  <p>(二)會員註冊時，及註冊期間所提供之資料，應為會員本人真實、正確、最新及完整的資料。會員註冊資料（如：個人資料及信用卡資料）不得有偽造、不實、冒用等之情事，一經發現，本軟體可拒絕其加入會員資格之權利，並得以暫停或終止其會員資格，若違反中華民國相關法律，亦將依法追究。</p>

                  <p>(三)若會員提供任何錯誤或不實之資料，除自行負擔因此而造成的損失外，本軟體有權不經事先通知，逕行暫停或終止會員帳號，並拒絕會員使用本服務之全部或一部份，且會員不得異議。本軟體將以註冊資料核對會員資格、提供本服務，並通知相關會員權益資訊，以及依據隱私權政策維護會員提供本軟體之個人資料。</p>

                  <p>(四)會員應妥善保管密碼，不可將密碼洩露或提供給他人知道或使用；以同一個會員帳號和密碼使用本服務所進行的所有行為，都將被認為是會員本人的行為。</p>

                  <p>(五)若會員為未滿七歲者，須由您的父母或法定監護人申請加入會員。若您已滿七歲未滿十八歲，則必須在申請加入會員之前，請父母或法定監護人閱讀本條款，並得到父母或監護人同意後，才可以申請、註冊及使用本軟體所提供的服務；當您滿十八歲之前使用本服務，則必須向本軟體擔保已取得父母或監護人的同意。</p>

                  <h2>四、服務說明</h2>

                  <p>(一)您理解並同意，本服務中包含付費服務與免付費服務，您可以依據各服務方案及利用本軟體所提供之付費方式，使用本軟體所提供之付費服務（以下簡稱「訂購服務」）。本服務若為需要付費方能使用之服務，本軟體會以顯著標註方式向您提示。</p>

                  <p>(二)您瞭解並同意於訂購前，已透過相關頁面中之說明，瞭解各訂購方案下本軟體所提供之功能、服務內容種類及費用。</p>

                  <p>(三)本公司如有贈送會員相關之優惠權益，亦有使用期限，會員應於期間將優惠權益使用完畢，逾期未使用則視同放棄優惠權益，本公司恕無法將未使用完畢之優惠權益累計或展延，亦不額外提供補償。</p>

                  <p>(四)您同意本公司可根據業務開展或技術升級等情況，變更或修改訂購服務之相關內容或功能等項目。本公司在做出上述改變或修改前，將在本軟體相關頁面上事先公告修改的內容與生效日。若您於生效日之後繼續使用訂購服務，則本公司將自動視為您已同意本公司訂購服務之修改或變更，本公司將以修改或變更後之訂購服務內容對您繼續提供服務。</p>

                  <p>(五)簡訊點數、獨立網域設定等等加購服務，屬於數位化商品，權限逾期無法退款，請您於購買前確認，並且同意再進行加購。</p>

                  <h2>五、付費方式與注意事項</h2>

                  <p>(一)您可利用下列方式付費訂購服務：信用卡付費：信用卡付費訂購服務後，原則以當月出帳並於次月扣款，惟實際依各付費平台公司之規定決定。</p>

                  <p>(二)若因過期、資金不足或其他原因導致付費失敗，則本公司可暫停您對服務的使用，直到本公司成功透過有效「付費方式」收費為止。</p>

                  <p>(三)針對部分付費方式，發行機構可能會向您收取特定費用，例如跨國交易手續費或其他針對您的付費方式之處理所收取的費用。當地稅額可能因所使用的付費方式而有所不同。詳情請諮詢您的付費方式服務提供者。</p>

                  <p>(四)您瞭解並同意本軟體之服務屬於「通訊交易解除權合理例外情事適用準則」第2條第5款「一經提供即為完成之線上服務」，不適用消費者保護法第19條猶豫期間解除權之規定。請於付費前，評估是否符合您的需求。</p>

                  <h2>六、智慧財產權</h2>

                  <p>(一)您使用本軟體所提供之功能服務時，如有上傳至本軟體之影片、歌曲等行為，您同意授權本軟體得利用您所上傳之內容及相關權利，行使服務所需之包括但不限於重製及改作等權利，您同意不對本公司行使相關權利（包括但不限於著作人格權等）。</p>

                  <p>
                    (二)您同意本服務所使用之功能、軟體、圖片、程式及網站上所有內容，包括但不限於影片、文字、圖片、檔案、資訊（料）、網站或APP畫面安排、設計及內容均由本軟體或其他權利人依法擁有其智慧財產權，包括但不限於商標權、專利權、著作權、營業秘密與專有技術等。除經本軟體及權利人授權或同意外，您不得擅自為著作權法、商標法及其他法規所規定之各式利用行為，亦不得擅自複製、進行還原工程（reverseengineering）、解編（de-compile）或反向組譯（disassemble）任何功能或程式。如有違反，本軟體將依相關法律規定論處，您並應對本軟體負損害賠償責任（包括但不限於訴訟費用及律師費用等），本軟體並得撤銷您會員之資格、禁止使用本服務，亦得永久拒絕您之會員申請。
                  </p>

                  <p>(三)除取得本軟體單次授權或永久授權外，您使用本服務而獲本軟體授權使用內容之一部或全部閱覽權，但並不因此而取得本軟體內容之智慧財產權和其他法律權利。</p>

                  <p>(四)如果本服務需有或內含可下載之素材或特效等功能，該功能可能會在提供新版時，在您的裝置上自動更新。部分情況下可以讓您調整您的自動更新設定。</p>

                  <h2>七、使用者／會員責任</h2>

                  <p>(一)您使用本軟體所提供之服務時，應遵守相關法律，並同意不得利用本服務從事侵害本軟體或他人權利或違法行為，此行為包含但不限於：</p>

                  <ol>
                    <li>上載、張貼、公布或傳送任何誹謗、侮辱、具威脅性、攻擊性、不雅、猥褻、不實、違反公共秩序或善良風俗或其他不法之文字、圖片或任何形式的檔案。</li>
                    <li>侵害他人名譽、隱私權、營業秘密、商標權、著作權、專利權、其他智慧財產權及其他權利。</li>
                    <li>違反法律、合約或協議所應負之保密義務。</li>
                    <li>為任何非法目的或以任何非法、不當方式使用本軟體及本服務（包含但不限於使用惡意爬蟲程式或進行還原工程解編或反向組繹）。</li>
                    <li>企圖入侵本軟體伺服器、資料庫、破解本軟體安全機制或其他危害本服務提供安全性或穩定性之行為。</li>
                    <li>從事不法交易行為或張貼虛假不實、引人犯罪之訊息。</li>
                    <li>未經本軟體明確授權同意並具書面授權同意證明，不得利用本服務或本軟體所提供其他資源，包括但不限於圖文、影音資料庫、編寫製作網頁之軟體等，從事任何商業交易行為，或招攬廣告商或贊助人。</li>
                    <li>販賣槍枝、毒品、盜版軟體或其他違禁物。</li>
                    <li>提供賭博資訊或以任何方式引誘他人參與賭博。</li>
                    <li>濫發廣告訊息、垃圾訊息、連鎖信、違法之多層次傳銷訊息等。</li>
                    <li>其他本軟體有正當理由認為不適當之行為。</li>
                  </ol>

                  <p>(二)您應對於使用本服務所從事的所有行為及其結果自行負擔一切責任。</p>

                  <p>
                    (三)若您發生或可能發生下列情事，本軟體不須事先告知，即可終止您使用本服務之全部或一部、停用或刪除本軟體帳戶、取消會員與本軟體之間關於本服務的合約（包括但不限於依據本條款成立的合約，以下皆同），或採取本軟體合理認為必要及適當的任何其他措施：1.違反相關法令、或本使用條款；2.透過散播不實資訊，例如利用詐欺方式或勢力，或透過其他不法方破壞本軟體或本公司的信譽；3.遭聲請被扣押、假扣押、拍賣、進入破產、民事重整或類似程序，或本軟體合理認為您的信用有不確定性；或4.與本軟體或本公司之間的信任關係已不存在，或因上列第1款至第4款以外事由，使本公司合理認為本軟體不再適合向您提供本服務。
                  </p>

                  <h2>八、第三方資源連結及下載</h2>

                  <p>本軟體可能含有連結至本軟體以外之第三方網站、或使用第三方應用程式、軟體（以下合稱「第三方資源」），由於本軟體無法控制這些第三方資源，因此您於使用各該第三方資源前，需自行瞭解各該第三方資源之使用者條款及隱私權政策。本軟體也不對第三方資源及裝置與服務的相容性或持續相容性提供任何保證。</p>

                  <h2>九、免責聲明與責任限制</h2>

                  <p>
                    (一)有下列情事之一者，本軟體有權暫停、變更或終止本服務之全部或一部，而對於會員因此所致損害，本軟體亦不負任何賠償或補償之責：1.本軟體之免付費服務；2.本服務相關軟硬體設備進行搬遷、更換、升級、保養或維修者；3.會員有任何違反政府法令或本服務條款者；4.天災或其他不可抗力事由；5.非本軟體所得控制之事由致本服務資訊顯示不正確、遭偽造、竄改、刪除或擷取或致系統中斷或不能正常運作時；6.其他不可歸責於本軟體之事由。
                  </p>

                  <p>(二)本軟體將依一般合理之技術與方式，維持本軟體及本服務之正常運作，然有以下各項情事者，本軟體有權自行停止、中斷之，並不負任何賠償或補償責任：1.本軟體或本服務所用之電子通信設備進行必要之保養或施工時；2.前款電子設備服務被停止，無法提供服務時；3.發生突發性之電子通信設備故障時；4.因不可抗力因素或其他不可歸責本軟體之事由，致本軟體無法提供服務時。</p>

                  <p>(三)本軟體對本服務不提供任何明示或默示之擔保，包括但不限於以下事項：1.本服務不受干擾、即時更新、安全可靠或免於錯誤；2.本服務使用而取得之結果為正確或可靠；3.經由本服務取得之任何商品、服務、資訊或其他資料將符合會員的需求或期望；</p>

                  <p>(四)使用本服務或取得任何資料應由會員自行評估並自行負擔風險，如因前述任何資料之下載而致會員於本軟體之任何損失或資料流失，均由會員自負完全責任。</p>

                  <p>(五)本軟體不因不可抗力事由所致之給付遲延、或給付不能負擔違約責任。</p>

                  <h2>十、終止服務</h2>

                  <p>(一)您使用本服務之行為若有任何違反法令、本條款、危害本軟體或第三者權益之虞時，在法律准許範圍內，於通知或未通知之情形下，立即暫時或永久終止您使用本服務之授權。此外，若本服務之使用被中斷或終止帳號及相關信息和文件被關閉或刪除，本軟體對您或任何第三人均不承擔任何責任。</p>

                  <p>(二)本服務一經終止後，不論是否已通知，均得刪除您會員之帳號及內容，本公司及本軟體並不承擔資料保存之義務。</p>

                  <p>(三)若本公司與根垣之合作關係終止時，本公司將停止提供售後教學及協助您向根垣反應本軟體運作及維修相關問題之服務，您應自行向根垣聯繫處理，且不得要求本公司提供任何服務或額外補償。</p>

                  <h2>十一、賠償</h2>

                  <p>(一)您擔保如本軟體及其管理階層、員工、代理人及承包商因您所為以下事項，而產生之第三人或本公司各樣主張、要求，致本公司受有損失、須負責任、損害賠償或支出（包括但不限於合理的律師費用）時，您同意負賠償責任：1.您所發布或遞交之內容；2.您違反本條款；3.您侵犯第三人之任何權利。</p>

                  <p>(二)起因於您使用本服務（包括但不限於本軟體遭第三人對於您使用本服務提出損害賠償請求），致本軟體直接或間接蒙受任何損失/損害（包括但不限於律師費用的負擔）時，您應依照本軟體的要求立即給予補償賠償。</p>

                  <p>(三)如本軟體因可歸責事由或理由而被認定需對您負擔損害賠償責任，本軟體就該事件的損害賠償額度上限為您所支付的訂購費用。</p>

                  <h2>十二、聯繫我們</h2>

                  <p>如對本條款或本軟體有任何疑問，請通過電子郵件（信箱：bombmy.live.tw@gmail.com）與我們聯繫。</p>

                  <h2>十三、準據法與管轄法院</h2>

                  <p>(一)本條款之解釋、補充及適用均以中華民國相關法令為準據法。本條款中任何條款之全部或一部份無效時，不影響其他條款之效力。</p>

                  <p>(二)因本條款所生之爭議，雙方同意以臺灣台中地方法院為第一審管轄法院。</p>
                </section>
              )}
              {termsTab === 'privacy' && (
                <section>
                  <h1>隱私權政策</h1>
                  <p>
                    感謝您使用開能有限公司（以下簡稱「我們」或「本公司」）協助銷售之「Bombmy幫賣」軟體（以下簡稱「本產品及服務」），本軟體由根垣科技有限公司開發並擁有全部智慧財產權與技術責任。為了讓您能夠安心的使用本公司所提供本產品及服務的各項服務與資訊，特此向您說明本產品及服務的隱私權政策（以下簡稱「本政策」），以說明我們如何蒐集、處理、利用、並保護您於使用我們提供的本產品及服務時所提供之個人資料（詳後定義），以及您可以如何存取、控管您的個人資訊。當您開始使用本產品及服務時，視為您已詳細閱讀、理解並同意本政策。
                  </p>
                  <h2>一、隱私權政策的適用範圍</h2>
                  <p>本政策適用於您使用本公司提供之本產品及服務。本產品及服務可能包含第三方網站之網路連結與使用第三方平台或功能，但本政策不適用於本平台以外的相關連結網站及內容，也不適用於本公司以外的第三方組織或人員。</p>
                  <h2>二、個人資料的蒐集、處理及利用之資料類型</h2>
                  <p>我們於您使用本產品及服務時可能蒐集之資料如下，並於本政策統稱為「個人資料」：</p>
                  <p>(一)您於使用本產品及服務時，主動提供給我們之資料，包含但不限於姓名、年齡、性別、出生年月日、聯絡地址、電話、電子郵件、身份證字號、居住國家、職業類別、認證資料等個人資料。</p>
                  <p>(二)您於使用本產品及服務時，自動蒐集之資料，包含但不限於伺服器自行產生的相關記錄（例如各個經造訪網站頁面之URL、使用連線設備IP位址、使用時間、瀏覽器、作業系統等）。</p>
                  <h2>三、蒐集、處理及利用資料之特定目的</h2>
                  <p>我們將於特定目的範圍，蒐集、處理、利用您的個人資料，包括：提供、執行、研發、維護、改善及開發本產品及服務；銷售、營銷、行銷和促銷；帳戶管理；客戶服務、財務和會計；防止詐欺、非法活動或濫用本產品及服務等。</p>
                  <h2>四、資料利用之期間及地區</h2>
                  <p>除您有行使權利或法規限制外，我們會於履行其被蒐集之目的所需期間內，保留您的個人資料。</p>
                  <h2>五、資料之保存及保護</h2>
                  <p>我們非常重視您個人資料之保護，本產品及服務已設置相關資訊安全設備及必要且適當的安全防護措施，以保護並避免您的個人資料被竊取、竄改、毀損、滅失或洩漏。</p>
                  <h2>六、與第三人共用個人資料之政策</h2>
                  <p>本產品及服務不會提供任何您的個人資料給其他個人、團體、私人企業或公務機關，但經您同意、法律明文規定、為免除您生命身體自由或財產上之危險等情形不在此限。</p>
                  <h2>七、您得行使之權利</h2>
                  <p>除法令另有規定外，您享有查詢或請求閱覽、請求製給複製本、請求補充或更正、請求停止蒐集處理或利用、請求刪除您提供之個人資料之權利。</p>
                  <h2>八、個人資料之正確性及不提供資料時對於權益之影響</h2>
                  <p>您有義務提供並隨時更新您的個人資料，若您拒絕提供、未提供完整個人資料或提供之個人資料有錯誤時，您將可能無法再使用本產品及服務所提供之部分或全部服務。</p>
                  <h2>九、隱私權政策之修正</h2>
                  <p>為保護您的隱私及提供更完整服務，本公司得適時修正本政策，並於公布更新於本產品及服務後，本政策之修正將立即生效。</p>
                  <h2>十、聯繫我們</h2>
                  <p>如您對本隱私權政策或本產品及服務之個人資料使用方法有任何疑問，請通過電子郵件（信箱：bombmy.live.tw@gmail.com）與本公司聯繫。</p>
                </section>
              )}
            </S.ModalBody>

            <S.ModalFooter>
              <S.ModalCloseBtn onClick={() => setShowTermsModal(false)}>我知道了</S.ModalCloseBtn>
            </S.ModalFooter>
          </S.ModalContainer>
        </S.ModalOverlay>
      )}
    </>
  )
}

export default Timer
